var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"column content-center",attrs:{"padding":""}},[_c('details-form'),_c('m-cta-button',{attrs:{"label":_vm.$t('continue'),"disabled":_vm.disabled},on:{"ctaClick":_vm.saveInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }